/**
 * Owner decision DEC-10: while a failed payment is inside the 14-day grace the customer keeps full access and the
 * shell shows this notice (flag from GET /v1/identity/me `access.banner`). Same look as the view-as banner.
 */
import type { Translate } from '@qm/i18n';
import { useApp } from '../lib/app-context';
import { useFormat } from '../lib/format';

export function PastDueBanner() {
  const { t, me } = useApp();
  const f = useFormat();
  if (me?.access?.banner !== 'payment_past_due') return null;
  return <PastDueBannerView t={t} graceUntil={me.access.graceUntil ? f.date(me.access.graceUntil) : null} />;
}

export function PastDueBannerView({ t, graceUntil }: { t: Translate; graceUntil: string | null }) {
  return (
    <div className="qm-viewas" role="status" data-testid="past-due-banner">
      <p className="qm-viewas__text">
        <b>{t('shell.pastDue.title')}</b>
        <span>{graceUntil ? t('shell.pastDue.until', { date: graceUntil }) : t('shell.pastDue.body')}</span>
      </p>
      <a className="qm-button" data-variant="ink" data-size="sm" href="/billing" data-testid="past-due-pay">{t('shell.pastDue.action')}</a>
    </div>
  );
}
